module.exports = __webpack_public_path__ + "img/angularjs.c1792ff8.png";